// extracted by mini-css-extract-plugin
module.exports = {"inlineVideoBlock":"style_inlineVideoBlock__q111F"};